'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { Route, IndexRoute } from 'react-router'; // Only import and use 'containers' for your route handlers

import Application from './containers/Application';
import Home from './containers/Home';
export default /*#__PURE__*/_jsx(Route, {
  path: "/",
  component: Application,
  children: /*#__PURE__*/_jsx(IndexRoute, {
    component: Home
  })
});